module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home",
    staticStyle: {
      "min-height": "500px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n  Le chiediamo di inserire il codice di consultazione del suo abstract. \n  ")]), _vm._v(" "), _c('el-form', {
    ref: "isAbs",
    attrs: {
      "model": _vm.abs,
      "rules": _vm.rules,
      "label-width": "180px"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onConsulta.apply(null, arguments)
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$teras.lang.codiceconsultazione,
      "prop": "codiceconsultazione"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.abs.codiceconsultazione),
      callback: function($$v) {
        _vm.$set(_vm.abs, "codiceconsultazione", $$v)
      },
      expression: "abs.codiceconsultazione"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticClass: "col s12 m3"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col s12 m6"
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onConsulta
    }
  }, [_vm._v("Procedi")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col s12 m3"
  })])], 1), _vm._v(" "), (_vm.esito) ? _c('div', [_c('h4', {
    staticClass: "yo-color-secondary",
    domProps: {
      "innerHTML": _vm._s(_vm.$teras.lang.esito)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca599640"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Abs-consulta.vue
// module id = 615
// module chunks = 2